// A first or last name: letters of any alphabet (with their combining marks), spaces, hyphens
// and apostrophes, at least one letter (AU-2-02). The backend applies the same rule.
export const PERSON_NAME_PATTERN = /^(?=.*\p{L})[\p{L}\p{M} '\u2019\u02BC-]+$/u;

export const NAME_RULE_MESSAGE =
  'A name may contain only letters, spaces, hyphens and apostrophes';
